module.exports = __webpack_public_path__ + "static/media/st.183bdadd.png";